/*
  Shared row styling for MenuItem and MenuRadioItem. Reka marks the hovered or
  keyboard-focused row with `data-highlighted` (it moves real focus on hover
  too, so `:focus-visible` cannot tell the two apart) and a disabled one with
  `data-disabled`. Menu sets `data-input` on the panel (`group/menu`) to the
  last input, so the highlighted row gets the fill for the pointer and the
  ring for the keyboard. Keep every utility a complete literal string, since
  Tailwind scans this file as text.
*/

export const menuItemBaseClass =
  'group flex min-h-[2.5rem] w-full cursor-pointer items-center gap-md rounded-sm px-lg py-sm text-body-md outline-none select-none group-data-[input=keyboard]/menu:data-[highlighted]:[outline:2px_solid_currentColor] group-data-[input=keyboard]/menu:data-[highlighted]:-outline-offset-2 data-[disabled]:cursor-default data-[disabled]:text-secondary-disabled';

export const menuItemRegularClass =
  'text-on-surface-primary group-data-[input=pointer]/menu:data-[highlighted]:bg-surface-container-hover';

export const menuItemDestructiveClass =
  'text-error group-data-[input=pointer]/menu:data-[highlighted]:bg-error-container';

export const menuItemIconClass =
  'shrink-0 text-on-surface-secondary group-data-[disabled]:text-secondary-disabled';

export const menuItemSelectedClass =
  'data-[state=checked]:not-data-[disabled]:text-primary';
